<template>
  <div class="form-input">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.form-input {
  @include displayCenter($justify-content: flex-start);
}
</style>
